import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartWaterfallAxis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChartWaterfallAxis"><Path d="M3.5 3.5V20.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 13.5V8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 16.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 10.5V5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 14.5V9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChartWaterfallAxis;
